




























import Vue from 'vue';
import { ISearchboxResultComponent, ISearchResultData } from '../../../common/interfaces/searchbox.interface';

export default Vue.extend({
  name: `KnowledgeBase`,
  data(): ISearchboxResultComponent {
    return {
      t: window.searchboxTexts,
    };
  },
  props: {
    isPartner: {
      required: true,
      type: Boolean,
    },
    searchResult: {
      required: true,
      type: Object as () => ISearchResultData,
    },
  },
});
